/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseRubricItemParser = /* #__PURE__ */ parsers.object([
    ['description', codecString],
    ['header', codecString],
    ['points', codecNumber],
]);
export class BaseRubricItem extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseRubricItemParser.decode(input).map(res => new BaseRubricItem(res));
    }
    static unsafeDecode(input) {
        return BaseRubricItem.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseRubricItemParser.encode(data);
    }
    static schema() {
        return BaseRubricItemParser.schema();
    }
}
